import { Accordion } from "@/components/ui/accordion";
import { FaqItem } from "./faq/FaqItem";
import { faqs } from "./faq/faqData";

export const FaqSection = () => {
  return (
    <section id="faq" className="py-12 md:py-16 px-4 bg-gray-900">
      <div className="max-w-2xl mx-auto">
        <h2 className="text-3xl font-bold text-white text-center mb-8">
          FAQ
        </h2>
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <FaqItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              index={index}
            />
          ))}
        </Accordion>
        <p className="text-center text-gray-400 mt-8 text-sm">
          Questions?{" "}
          <a
            href="mailto:help@propertyvue.io"
            className="text-blue-400 hover:underline"
          >
            help@propertyvue.io
          </a>
        </p>
      </div>
    </section>
  );
};
